import PropTypes from 'prop-types';

const CompanyLeadShape = PropTypes.shape({
  company_name: PropTypes.string,
  email: PropTypes.string,
  full_name: PropTypes.string,
});

export default CompanyLeadShape;
